import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { formatTime } from '@/core';
import { fetchDashboardTodos, type DashboardTodoItem } from '@/api/dashboard';

/** app store — 面包屑、数据刷新时间、动效降级（?static）、告警未读角标 */
export const useAppStore = defineStore('app', () => {
  const crumb = ref('中控看板');
  const refreshedAt = ref<Date>(new Date());
  const todoItems = ref<DashboardTodoItem[]>([]);
  const sidebarCollapsed = ref(false);

  /** 从后端拉取真实待办列表 */
  async function loadTodos(): Promise<void> {
    try {
      const todos = await fetchDashboardTodos();
      todoItems.value = todos.items ?? [];
    } catch {
      // 接口失败时不亮红点
      todoItems.value = [];
    }
  }

  /** 红点判据：items 中存在 count >= 1 的条目 */
  const alertUnread = computed(() => todoItems.value.some((item) => item.count >= 1));

  /** ?static 关闭动效：用于截图与低性能设备（原型同款降级开关） */
  const staticMode = computed(() => {
    const hash = window.location.hash || '';
    const search = window.location.search || '';
    return /[?&]static\b/.test(hash) || /[?&]static\b/.test(search);
  });

  function setCrumb(value: string): void {
    crumb.value = value;
  }

  function markRefreshed(at = new Date()): void {
    refreshedAt.value = at;
  }

  const refreshedText = computed(() => `数据更新于 ${formatTime(refreshedAt.value)}`);

  function toggleSidebar(): void {
    sidebarCollapsed.value = !sidebarCollapsed.value;
  }

  return { crumb, refreshedAt, refreshedText, alertUnread, todoItems, sidebarCollapsed, staticMode, setCrumb, markRefreshed, toggleSidebar, loadTodos };
});
